/* eslint-disable @typescript-eslint/no-explicit-any */
import { getListSolicitud, getListTwoLevel } from "../request/request";
import { LabelValue } from "./tickets";

export async function fetchTopics(api: any, type: "Change Request" | "Incident Report", productValue: string) {
  const resp = await getListSolicitud(api, type, productValue);
  return resp.data as LabelValue[];
}

export async function fetchTwoLevels(api: any, type: "Change Request", productValue: string, topicLabel: string) {
  const resp = await getListTwoLevel(api, type, productValue, topicLabel);
  return resp.data as LabelValue[];
}
